import ReportFieldsFilter from './ReportFieldsFilter';

export default ReportFieldsFilter;
